<template>
    <v-btn
        v-if="yClientsHrefInfo && !isAltegio"
        class="svg-icon"
        icon
        @click="openInNewTab(getClientRefFromParsed(yClientsHrefInfo))"
        :style="`width:${btnWidth}px;height:${btnHeight}px`"
    >
        <v-icon :size="size" color="mainNew">{{ '$vuetify.icons.yClients' }}</v-icon></v-btn
    >
</template>

<script>
import { openInNewTab } from '@root/src/utils'
import { getClientRefFromParsed } from '../chisai/getClientsBack/helpers'
import { CONNECTOR_TYPES } from '@root/src/vars/general'

export default {
    name: 'yClientsLink',
    components: {},
    props: {
        hrefInfo: {
            type: Array,
            default: () => [],
        },
        size: {
            type: Number,
            default: 18,
        },
        btnWidth: {
            type: Number,
            default: 36,
        },
        btnHeight: {
            type: Number,
            default: 36,
        },
    },
    data: () => ({}),
    computed: {
        yClientsHrefInfo() {
            return this?.hrefInfo?.find(el => el.connectorType === CONNECTOR_TYPES.yClients)
        },
        project() {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        isAltegio() {
            return this.project.connectors.find(el => el.connectorType === CONNECTOR_TYPES.yClients)?.isAltegio
        },
    },
    methods: { openInNewTab, getClientRefFromParsed },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'
</style>
